var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"liste"}},[_c('HeaderTab',{attrs:{"title":_vm.$t('compta.export.title_page')}}),_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container-fluid"},[_c('ExportConfig')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }